import { useEffect, useState } from "react";
import config from '../settings/config';
// import { useNavigate, useLocation } from "react-router-dom";

const useBackendStatus = (checkInterval = 5000) => {
    const [isOnline, setIsOnline] = useState(true);

    console.log(isOnline)

    useEffect(() => {
        const checkBackend = async () => {
            try {
                const response = await fetch(`${config.app.host}/api/v1/ping`, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                            });
                if (!response.ok) throw new Error("Backend is down");
                setIsOnline(true);
                
            } catch (error) {
                setIsOnline(false);
            }
        };

        checkBackend(); // Проверяем при загрузке
        const interval = setInterval(checkBackend, checkInterval);

        return () => clearInterval(interval);
    }, [checkInterval]);

    return isOnline;

};

export default useBackendStatus;

